// src/firebase-app-core.js
// Minimal Firebase bootstrap for the app shell:
// - initialize default app once
// - expose Auth eagerly (used on first paint by AuthContext)
// - keep Firestore/Storage/Functions out of this module so they can be
//   loaded on-demand by feature chunks.

import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, initializeAuth, inMemoryPersistence } from "firebase/auth";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

// This module is loaded on first paint (by AuthContext), so it is usually the
// FIRST place the default app's Auth is created. Firebase Auth's default
// IndexedDB persistence HANGS during init inside the Capacitor iOS WKWebView —
// and because Firestore waits for an auth token before any read, that hang
// freezes the whole app on "Loading…". We must therefore create Auth here with
// the same in-memory persistence firebase.js uses; otherwise getAuth() here
// wins with the default IndexedDB persistence and firebase.js's later
// initializeAuth() just throws "already-initialized" and is ignored.
let _auth;
try {
  _auth = initializeAuth(firebaseApp, { persistence: [inMemoryPersistence] });
} catch (e) {
  // Already initialized (HMR / load-order) — reuse the existing instance.
  _auth = getAuth(firebaseApp);
}
export const auth = _auth;
